import { DatePickerSelect } from '../DatePickerSelect/DatePickerSelect';
import { CalendarArrowRight, CalendarArrowLeft } from 'components';

type Props = {
  monthDate: Date;
  changeYear: (props: any) => void;
  changeMonth: (props: any) => void;
  decreaseMonth: (props: any) => void;
  increaseMonth: (props: any) => void;
  onChange: (...args: any) => void;
  showMonthPicker?: boolean;
  showYearPicker?: boolean;
  prevMonthButtonDisabled?: boolean;
  nextMonthButtonDisabled?: boolean;
  onCalendarClose?: () => void;
  datepickerRef?: any;
  minDate?: Date;
  maxDate?: Date;
};

export const DatePickerHeader: React.FC<Props> = ({
  monthDate,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  showMonthPicker,
  showYearPicker,
  minDate,
  maxDate,
}) => {
  // helper function for making a range of years inclusive
  function* range(start: number, end: number, step = 1) {
    const min = Math.min(start, end);
    const max = Math.max(start, end);
    if (start > end) {
      //if range is reversed start from end and count down by step
      step *= -1;
    }
    while (start <= max && start >= min) {
      yield start;
      start += step;
    }
  }

  const currentYear = new Date().getFullYear();
  const startYear = minDate?.getFullYear() || 1950;
  const endYear = maxDate?.getFullYear() || currentYear + 5;

  const years = Array.from(range(endYear, startYear));
  const months = Array.from(Array(12), (_, idx) => {
    const date = new Date(2000, idx, 1);
    const month = date.toLocaleString(['en-US'], { month: 'long' });
    return month;
  });

  return (
    <>
      <div
        style={{ color: 'rgb(107 114 128)' }}
        className='d-flex px-1 justify-content-between align-items-center'
      >
        <CalendarArrowLeft onClick={decreaseMonth} size='16px' />
        <div className='d-flex'>
          {showMonthPicker && (
            <DatePickerSelect
              value={{
                label: months[monthDate.getMonth()],
                value: monthDate.getMonth(),
              }}
              onChange={({ value }) => changeMonth(value)}
              options={months.map((month, index) => ({
                label: month,
                value: index,
              }))}
            />
          )}

          {showYearPicker && (
            <DatePickerSelect
              value={{
                label: monthDate.getFullYear(),
                value: monthDate.getFullYear(),
              }}
              onChange={({ value }) => changeYear(value)}
              options={years.map((year) => ({
                label: String(year),
                value: year,
              }))}
            />
          )}
        </div>
        <CalendarArrowRight onClick={increaseMonth} size='16px' />
      </div>
    </>
  );
};
